module.exports = __webpack_public_path__ + "img/JP-img.afeb422f.png";